import { Control, FieldPath, FieldValues } from "react-hook-form";

import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/_atoms/form";
import { Input } from "@/components/_atoms/input";

interface InviteTextFieldProps<TFieldValues extends FieldValues> {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
  label: string;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
}

export function InviteTextField<TFieldValues extends FieldValues>({
  control,
  name,
  label,
  type,
  placeholder,
  disabled,
}: InviteTextFieldProps<TFieldValues>) {
  return (
    <FormField
      control={control}
      name={name}
      disabled={disabled}
      render={({ field }) => (
        <FormItem className="space-y-0.5">
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Input type={type} placeholder={placeholder} {...field} aria-label={label} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
